import { Component } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Validators } from '@angular/forms/src/validators';
import * as fromRoot from '../reducers';
import * as actions from '../actions/user';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-user-agreement',
  template: `
    <div class="row justify-content-center">
      <div class="col-md-10 text-center">
        <h4>Please accept the user agreement to continue.</h4>
        <iframe src="useragreement.pdf" width="100%" height="500" frameborder="1" style="margin:20px 0;"></iframe>
      </div>
    </div>
    <form [formGroup]="form" (ngSubmit)="acceptAgreement()">
      <div class="row justify-content-center">
        <div class="col-md-5">
          <label>
            <input type="checkbox" formControlName="accepted" />
            I accept the terms of the above user agreement.
          </label>
        </div>
        <div class="col-md-2 text-right">
          <button class="btn btn-sm btn-outline-success" [disabled]="!form.valid">Accept</button>
        </div>
      </div>
    </form>
  `,
  styles: [`
    label:hover, input:hover{
      cursor:pointer;
    }
  `]
})
export class UserAgreementContainerComponent {
  form: FormGroup;

  constructor(fb: FormBuilder,
              private store: Store<fromRoot.State>) {
    this.form = fb.group({
      'accepted': [null]
    });
  }

  acceptAgreement() {
    if (this.form.controls['accepted'].value) {
      this.store.dispatch(new actions.AcceptUserAgreementAction());
    } else {
      alert('The checkbox must be selected to accept the agreement.');
    }
  }
 }



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/containers/user-agreement.ts